import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useCart } from '../state/CartContext'
import { useI18n } from '../state/I18nContext'
import { CartIcon } from './Icons'
import Drawer from './Drawer'

const Navbar: React.FC = () => {
  const [open, setOpen] = useState(false)
  const { state } = useCart()
  const { t, locale, setLocale } = useI18n()
  const count = state.items.reduce((n, i) => n + i.qty, 0)
  const home = `/${locale}/`
  const l = t.landing.nav

  const navLinks = [
    { label: l.historia, anchor: 'historia' },
    { label: l.encomendas, anchor: 'produtos' },
    { label: l.processo, anchor: 'processo' },
    { label: l.faq, anchor: 'faq' },
    { label: l.envios, anchor: 'envios' },
  ]

  return (
    <header
      className="sticky top-0 z-50 border-b border-[#e8dece]"
      style={{ background: 'rgba(250,246,239,0.93)', backdropFilter: 'blur(10px)' }}
    >
      <div className="flex items-center justify-between px-10 py-5">
        <Link
          to={home}
          className="text-2xl font-semibold tracking-[0.04em] text-[#6b4f2e] no-underline"
          style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
        >
          Caladin<em className="italic font-light text-[#9a7249]">hos</em>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8">
          <ul className="flex gap-8 list-none m-0 p-0">
            {navLinks.map(link => (
              <li key={link.anchor}>
                <a
                  href={`${home}#${link.anchor}`}
                  className="text-[0.82rem] font-medium tracking-[0.1em] uppercase text-[#6b5d4f] no-underline hover:text-[#6b4f2e] transition-colors"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href={`${home}#produtos`}
            className="text-[0.82rem] font-medium tracking-[0.1em] uppercase text-[#faf6ef] px-5 py-2 rounded-[2px] no-underline transition-colors hover:opacity-90"
            style={{ background: '#6b4f2e' }}
          >
            {l.encomendar}
          </a>
          <Link to={`/${locale}/cart`} className="relative flex items-center text-[#6b4f2e]">
            <CartIcon className="w-5 h-5" />
            {count > 0 && (
              <span className="absolute -top-2 -right-3 text-xs bg-[#6b4f2e] text-[#faf6ef] rounded-full px-1.5 py-0.5 leading-none">
                {count}
              </span>
            )}
          </Link>
          <select
            aria-label={t.ui.language}
            className="rounded border border-[#e8dece] px-2 py-1 text-sm bg-transparent text-[#6b5d4f] cursor-pointer"
            value={locale}
            onChange={e => setLocale(e.target.value as any)}
          >
            <option value="pt">PT</option>
            <option value="en">EN</option>
            <option value="fr">FR</option>
            <option value="es">ES</option>
          </select>
        </nav>

        {/* Mobile controls */}
        <div className="md:hidden flex items-center gap-3">
          <Link to={`/${locale}/cart`} className="relative text-[#6b4f2e]">
            <CartIcon className="w-6 h-6" />
            {count > 0 && (
              <span className="absolute -top-2 -right-3 text-xs bg-[#6b4f2e] text-[#faf6ef] rounded-full px-1.5 py-0.5 leading-none">
                {count}
              </span>
            )}
          </Link>
          <button
            aria-label={t.ui.menu}
            onClick={() => setOpen(o => !o)}
            className="p-2 rounded border border-[#e8dece]"
          >
            <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5 text-[#2a1f0e]">
              <path fillRule="evenodd" d="M3 6.75A.75.75 0 013.75 6h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 6.75zM3 12a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 12zm0 5.25a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75a.75.75 0 01-.75-.75z" clipRule="evenodd" />
            </svg>
          </button>
        </div>
      </div>

      <Drawer open={open} onClose={() => setOpen(false)} title={t.ui.menu} closeLabel={t.ui.close}>
        <nav className="flex flex-col gap-4 p-4">
          {navLinks.map(link => (
            <a
              key={link.anchor}
              href={`${home}#${link.anchor}`}
              onClick={() => setOpen(false)}
              className="text-sm font-medium uppercase tracking-widest text-[#6b5d4f] hover:text-[#6b4f2e] no-underline"
            >
              {link.label}
            </a>
          ))}
          <a
            href={`${home}#produtos`}
            onClick={() => setOpen(false)}
            className="text-sm font-medium uppercase tracking-widest text-center text-[#faf6ef] px-4 py-2 rounded-[2px] no-underline"
            style={{ background: '#6b4f2e' }}
          >
            {l.encomendar}
          </a>
          <select
            aria-label={t.ui.language}
            className="border border-[#e8dece] rounded px-2 py-1 text-sm"
            value={locale}
            onChange={e => setLocale(e.target.value as any)}
          >
            <option value="pt">PT</option>
            <option value="en">EN</option>
            <option value="fr">FR</option>
            <option value="es">ES</option>
          </select>
        </nav>
      </Drawer>
    </header>
  )
}

export default Navbar
